import Vue, { DirectiveOptions, PluginObject, PluginFunction } from 'vue';
import PortalVue from 'portal-vue';
import { VueClass } from 'vue-class-component/lib/declarations';

export const registerComponents = () => {
	const [components, filters, directives] = window.aurora;

	Vue.use(PortalVue as PluginFunction<any>);
	Vue.use(directives as PluginObject<any>);
	Vue.use(filters as PluginObject<any>);

	Object.keys(components).forEach((componentKey: string) => {
		const component = (<Record<string, VueClass<any>>>components)[componentKey];

		if (component.name) {
			Vue.component(component.name.toLowerCase(), component);
		}
	});
};
